function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { InputWrapper } from '../../units/input-wrapper';
export function TextArea(props, state) {
  var _a;

  var className = props.className,
      disabled = props.disabled,
      rows = props.rows,
      value = props.value,
      onPressEnter = props.onPressEnter,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      onKeyDown = props.onKeyDown,
      invalid = props.invalid,
      filled = props.filled,
      extra = _objectWithoutProperties(props, ["className", "disabled", "rows", "value", "onPressEnter", "onChange", "onValueChange", "onKeyDown", "invalid", "filled"]);

  var locale = useLocale('textarea.placeholder');
  var onPressEnterCallback = useRefCallback(onPressEnter);
  var onChangeCallback = useRefCallback(onChange);
  var onKeyDownCallback = useRefCallback(onKeyDown);
  var onValueChangeCallback = useRefCallback(onValueChange);
  var handleTextareaChange = useCallback(function (e) {
    onChangeCallback(e);
    onValueChangeCallback(e.target.value);
  }, []);

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 13) {
      onPressEnterCallback(e);
    }

    onKeyDownCallback(e);
  };

  var cls = classnames(usePrefixCls('text', {
    disabled: disabled
  }), usePrefixCls('text', {
    enabled: !disabled
  }), usePrefixCls('text', {
    warning: invalid && !disabled
  }), usePrefixCls('text', {
    filled: filled
  }), className);
  return React.createElement(InputWrapper, Object.assign({}, extra, {
    tag: "textarea",
    rows: rows,
    disabled: disabled,
    placeholder: (_a = extra.placeholder) !== null && _a !== void 0 ? _a : locale,
    value: value,
    inputClassName: cls,
    onKeyDown: handleKeyDown,
    onChange: handleTextareaChange
  }));
}